import { render } from "./AmoCrmWhatsapp.vue?vue&type=template&id=1307bba7&scoped=true&ts=true"
import script from "./AmoCrmWhatsapp.vue?vue&type=script&lang=ts"
export * from "./AmoCrmWhatsapp.vue?vue&type=script&lang=ts"

import "./AmoCrmWhatsapp.vue?vue&type=style&index=0&id=1307bba7&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1307bba7"]])

export default __exports__